const initState = {
  successFetching: false,
  errorFetching: false,
  document: null,
  documents: null,
};

export default initState;
